import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommIFStatus } from '@models/system-status';
import { SystemStatusService } from '@service/system-status.service';
import { Subject, takeUntil } from 'rxjs';
import * as _ from 'lodash';
import { SystemStatusSocketService } from '@service/system-status-socket.service';

@Component({
    selector: 'app-ops-system-status',
    templateUrl: './ops-system-status.component.html',
    styleUrls: ['./ops-system-status.component.scss'],
    standalone: false,
})
export class OpsSystemStatusComponent implements OnInit, OnDestroy {
    selectedPage: SystemPageType;
    overviewPage = SystemPageType.Overview;
    eapPage = SystemPageType.Eap;
    opsPage = SystemPageType.Ops;
    fcuPage = SystemPageType.Fcu;
    commsPage = SystemPageType.Comms;
    printersPage = SystemPageType.Printers;

    systemStatusData: any = null;
    selectedCommIF: CommIFStatus = null;
    selectedFcuSrc: string = null;

    systemStatusConnected: boolean = true;

    private destroySubscriptionSubject$ = new Subject<void>();

    constructor(
        private systemStatusService: SystemStatusService,
        private systemStatusSocket: SystemStatusSocketService,
        private cdr: ChangeDetectorRef,
    ) {}

    async ngOnInit() {
        this.handlePageSelected(SystemPageType.Overview);
        this.systemStatusData = await this.systemStatusService.getSystemStatusData();
        this.systemStatusConnected = this.systemStatusSocket.getIsReceivingData();

        this.systemStatusSocket
            .updateStatusSubject()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe((updatedStatus) => {
                if (!this.systemStatusConnected) return;
                this.systemStatusData = updatedStatus;
                this.cdr.detectChanges();
            });

        this.systemStatusSocket
            .updateConnectionSubject()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(async (isReceivingData) => {
                if (this.systemStatusConnected == isReceivingData) return;
                this.systemStatusConnected = isReceivingData;
                if (isReceivingData) {
                    this.systemStatusData = await this.systemStatusService.getSystemStatusData();
                }
                this.cdr.detectChanges();
            });

        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    handlePageSelected(page: SystemPageType) {
        this.selectedPage = page;
    }

    simulatorIsRunning() {
        return this.systemStatusData;
    }
}

export enum SystemPageType {
    Undefined = '',
    Overview = 'overview',
    Eap = 'eap',
    Ops = 'ops',
    Fcu = 'fcu',
    Comms = 'comms',
    Printers = 'printers',
}
